import { useQuery } from '@tanstack/react-query';
import { useWatch } from 'react-hook-form';
import { useCompanyContext } from '../../../../context/CompanyContext';
import { fetchPCReimburusements } from '../../../../services/accounting/PayrollService';
import { ReimbursementFilters } from './PCReimbursementFilters';
import { getSubmittedDraft } from './utils';

const PCReimbursementReportHeader = () => {
  const { selectedCompany } = useCompanyContext();
  const filters = useWatch<ReimbursementFilters>();

  const submittedPCReimburusements = useQuery({
    queryKey: ['getSubmittedPCReimburusements', selectedCompany],
    queryFn: ({ signal }) =>
      fetchPCReimburusements(
        {
          companyID: selectedCompany!.id,
          isSubmitted: true,
          isApproved: false,
        },
        signal
      ),
    refetchOnWindowFocus: false,
    enabled: false,
  });

  return (
    <div className="blackText printMedia printShow">
      <div className="text-30px text-center mt-5">{selectedCompany!.name}</div>
      <div className="text-28px text-center">Petty Cash Reimbursement</div>
      <div className="text-17px ml-3 mt-2">
        {filters.submittedID && (
          <div>
            <span className="font-bold mr-1">Submitted Draft:</span>
            {getSubmittedDraft(
              filters.submittedID,
              submittedPCReimburusements.data
            )}
          </div>
        )}
      </div>
      <div className="ml-3 text-17px mb-5">
        <span className="font-bold mr-1">Created at:</span>
        {new Date().toLocaleString()}
      </div>
    </div>
  );
};

export default PCReimbursementReportHeader;
